import styled from 'styled-components';
import { BodyLarge400, BodyMedium400 } from '@nebula/global-styles';

export const StyledBodyLarge400 = styled(BodyLarge400)`
  margin-top: 0.5rem;
`;

export const StyledBodyMedium400 = styled(BodyMedium400)`
  margin-top: 0.5rem;
`;
